/**
 * Layer system — z-index ranges for proper stacking.
 * 
 * LAYER 0: Background         z: 0–9
 * LAYER 1: Decorations         z: 10–99
 * LAYER 2: Content             z: 100–499
 * LAYER 3: Navbar / sticky UI  z: 500–899
 * LAYER 4: Admin / editor UI   z: 9000+
 */

export const LAYER = {
  BACKGROUND: { name: "Fond", min: 0, max: 9, default: 1 },
  DECORATION: { name: "Décoration", min: 10, max: 99, default: 20 },
  CONTENT: { name: "Contenu", min: 100, max: 499, default: 100 },
  NAVBAR: { name: "Navigation", min: 500, max: 899, default: 500 },
  ADMIN: { name: "Éditeur", min: 9000, max: 9999, default: 9990 },
} as const;

export type LayerName = keyof typeof LAYER;

export const LAYER_PRESETS = [
  { label: "Derrière tout (fond)", layer: "BACKGROUND" as LayerName, z: 1 },
  { label: "Derrière le contenu", layer: "DECORATION" as LayerName, z: 20 },
  { label: "Avec le contenu", layer: "CONTENT" as LayerName, z: 100 },
  { label: "Devant le contenu", layer: "CONTENT" as LayerName, z: 200 },
  { label: "Derrière la navbar", layer: "DECORATION" as LayerName, z: 90 },
] as const;

export function getLayerForZIndex(z: number): LayerName {
  if (z >= LAYER.ADMIN.min) return "ADMIN";
  if (z >= LAYER.NAVBAR.min) return "NAVBAR";
  if (z >= LAYER.CONTENT.min) return "CONTENT";
  if (z >= LAYER.DECORATION.min) return "DECORATION";
  return "BACKGROUND";
}

export function getLayerLabel(z: number): string {
  const layer = getLayerForZIndex(z);
  return LAYER[layer].name;
}

export function clampToLayer(z: number, layer: LayerName): number {
  const { min, max } = LAYER[layer];
  return Math.max(min, Math.min(max, z));
}
